module.exports = __webpack_public_path__ + "static/media/Wallow.svg";